import { Mapper } from "../../../../../base/utils/mapper";
import { CompanyModel } from "../../../../../domain/models/configuration/company/company.model";
import { CompanyEntity } from "../../entities/company/company.entity";



export class CompanyImplementationRepositoryMapper extends Mapper<CompanyEntity, CompanyModel> {
    mapFrom(param: CompanyEntity): CompanyModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: CompanyModel): CompanyEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}